import { Box, useTheme } from '@hover/blueprint';
import React from 'react';

import { DetailsContactInfo } from 'src/modules/homeownerApp/components/ProjectShare/DetailsContactInfo';
import { DetailsHeading } from 'src/modules/homeownerApp/components/ProjectShare/DetailsHeading';
import { DetailsLinkOut } from 'src/modules/homeownerApp/components/ProjectShare/DetailsLinkOut';

export const Details = () => {
  const { breakpoints } = useTheme();

  return (
    <Box flexDirection={{ base: 'column', tablet: 'row' }}>
      <Box
        alignItems={{ tablet: 'center' }}
        flexDirection="column"
        justifyContent="center"
      >
        <Box
          flexDirection="column"
          gap={{ base: 100, tablet: 200 }}
          maxWidth={{ tablet: breakpoints.width100 }}
          paddingX={{ tablet: 500 }}
        >
          <DetailsHeading />
          <DetailsContactInfo />
          <DetailsLinkOut />
        </Box>
      </Box>
    </Box>
  );
};
